import type { HostingLibraryContext } from '@/core/interfaces/HostingLibraryContext.interface'

import { isSystemAssembly } from './isSystemAssembly'
import { normalizeAssemblyName } from './normalizeAssemblyName'

export const isHostingAssemblyReference = (
  assemblyName: string | undefined,
  hostingLibrary: HostingLibraryContext | undefined
): boolean => {
  if (!hostingLibrary) return false

  const normalizedAssembly = normalizeAssemblyName(assemblyName)
  if (!normalizedAssembly || isSystemAssembly(normalizedAssembly)) return false

  if (normalizedAssembly === hostingLibrary.libraryName) return true

  return hostingLibrary.moduleFullNames.has(normalizedAssembly)
}
